function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BarChart from './BarChart';
import { StackUtils } from '../Shared/StackUtils';
import * as d3 from 'd3';
import dc from 'dc';
/**
 * Renders an ordinal barchart
 */

export var BarChartStacked = /*#__PURE__*/function (_Component) {
  _inheritsLoose(BarChartStacked, _Component);

  function BarChartStacked() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = BarChartStacked.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        dimension = _this$props.dimension,
        stackKey = _this$props.stackKey,
        valueKey = _this$props.valueKey,
        renderLabel = _this$props.renderLabel; // Get all unique types

    var types = StackUtils.getUnique(dimension, stackKey); // Create group

    var group = dimension.group().reduce(function add(p, v) {
      p[v[stackKey]] += parseInt(v[valueKey], 10);
      return p;
    }, function remove(p, v) {
      p[v[stackKey]] -= parseInt(v[valueKey], 10);
      return p;
    }, function init(p, v) {
      var ret = {};

      for (var i = 0; i < types.length; i++) {
        ret[types[i]] = 0;
      }

      return ret;
    });

    var titleFunction = function titleFunction(d) {
      return d.key + '[' + this.layer + ']: ' + d.value[this.layer];
    };

    return /*#__PURE__*/React.createElement(BarChart, _extends({
      id: this.props.id,
      x: d3.scaleBand(),
      xUnits: dc.units.ordinal,
      barPadding: 0.1,
      outerPadding: 0.05,
      group: group,
      groupName: types[0],
      groupSelectionFunction: StackUtils.selStack(types[0]),
      stack: types,
      title: titleFunction,
      clipPadding: 10,
      legend: dc.legend().x(50).y(10).autoItemWidth(true).horizontal(true).gap(5),
      renderLabel: renderLabel,
      margins: [35, 0, 20, 50]
    }, this.props));
  };

  return BarChartStacked;
}(Component);

_defineProperty(BarChartStacked, "defaultProps", {
  renderLabel: false
});

BarChartStacked.propTypes = process.env.NODE_ENV !== "production" ? {
  stackKey: PropTypes.string.isRequired,
  valueKey: PropTypes.string.isRequired,
  dimension: PropTypes.object,
  renderLabel: PropTypes.bool
} : {};
export default {
  BarChartStacked: BarChartStacked
};